import { getAthleteDatasources } from 'api/integrations/storyblok/datasources/getAthleteDatasources'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import Head from 'next/head'
import { AthleteListingProps } from 'components/athletes'
import { FresnoAthletesPage } from 'components/athletes/fresno/FresnoAthletesPage'
import Footer from 'components/landing-page/Footer'
import NavbarLayout from 'components/navbar/NavbarLayout'

const FresnoAthletes = ({
  athleteDatasources,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <NavbarLayout notificationBar={athleteDatasources.notificationBar?.items}>
    <Head>
      <title>Athletes - California State University, Fresno</title>
      <meta
        content="Book Our California State University, Fresno Athletes For Position Specific Sports Training"
        name="description"
      />
      <meta content="Athletes - California State University, Fresno" property="og:title" />
      <meta
        content="Book Our California State University, Fresno Athletes For Position Specific Sports Training"
        property="og:description"
      />
      <meta content="Athletes - California State University, Fresno" property="twitter:title" />
      <meta
        content="Book Our California State University, Fresno Athletes For Position Specific Sports Training"
        property="twitter:description"
      />
      <meta property="og:type" content="website" />
    </Head>
    <FresnoAthletesPage athleteDatasources={athleteDatasources} />
    <Footer />
  </NavbarLayout>
)

export const getServerSideProps: GetServerSideProps<AthleteListingProps> = async () => {
  const athleteDatasources = await getAthleteDatasources()

  return {
    props: {
      athleteDatasources,
    },
  }
}

export default FresnoAthletes
